import { render, staticRenderFns } from "./MakePayment.vue?vue&type=template&id=90f4ace0&scoped=true&"
import script from "./MakePayment.vue?vue&type=script&lang=js&"
export * from "./MakePayment.vue?vue&type=script&lang=js&"
import style0 from "./MakePayment.vue?vue&type=style&index=0&id=90f4ace0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90f4ace0",
  null
  
)

export default component.exports